module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.27a90e87.otf";


//////////////////
// WEBPACK FOOTER
// ./public/assets/fonts/Gotham Fonts/Gotham-Medium.otf
// module id = 1184
// module chunks = 0